import { createFileRoute, redirect } from "@tanstack/react-router";
import { ConfirmEnrolment } from "@/features/seat-orders/components/ConfirmEnrolment";
import { fetchFeatureFlags } from "@/hooks/useFeatureFlags";
import { useAuthStore } from "@/stores/authStore";

export const Route = createFileRoute("/_app/my-purchases_/seat-orders/$seatOrderId_/take-seat")({
  // Seat orders are hidden while the payments or seat-orders flag is off (the API 404s them too).
  beforeLoad: async () => {
    const { payments, seatOrders } = await fetchFeatureFlags();
    if (!payments || !seatOrders) throw redirect({ to: "/my-purchases" });
  },
  component: TakeSeatPage,
});

/**
 * TakeSeatPage - The purchaser taking a seat on their own order for themselves (LMS-189): Confirm enrolment for their
 * own account, without an invite, on a seat they haven't invited anyone to. Only the order's purchaser gets past the
 * lookup; anyone else is told the order couldn't be checked, as the API answers 404.
 */
function TakeSeatPage() {
  const { seatOrderId } = Route.useParams();
  const user = useAuthStore((state) => state.user);
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");

  return (
    <div className="flex justify-center px-4 py-16">
      <ConfirmEnrolment seatOrderId={seatOrderId} account={{ name, email: user?.email ?? "" }} />
    </div>
  );
}
